import { Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { MinStdItemGathering } from '@/module/MinimalStandard/components/MinStdItemGathering';
import { getMinStdAnnexTemplateOptions, getMinStdOptions } from '@/module/MinimalStandard/model/MinStdQuery';

import { PendingSpinner } from '@/core/components';

export const Route = createFileRoute('/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = Route.useSearch();
  const { indicatorCode } = Route.useParams();
  const { data: report } = useSuspenseQuery(getMinStdOptions(Number(userId)));
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { data: template } = useSuspenseQuery(getMinStdAnnexTemplateOptions(report!.minStdAnnexNo!));
  const indicators = template.indicators;

  const index = indicators.map(c => c.indicatorCode).indexOf(indicatorCode);
  const indicator = indicators[index];

  const startYear = 1990;
  const endYear = 2025;

  return (
    <>
      {userId != null && (
        <Suspense fallback={<PendingSpinner h="300px" />}>
          <MinStdItemGathering
            key={`${indicatorCode}-${userId}`}
            indicator={indicator}
            authorId={Number(userId)}
            startYear={startYear}
            endYear={endYear}
          />
        </Suspense>
      )}
      {userId == null && <Text>Utilizator neselectat</Text>}
    </>
  );
}
